import { ConditionalPartial } from '../../../../utils';

import { CreateDestructionProcessConfigRequestDto } from './create-destruction-process-config.request.dto';

/**
 * DTO for updating destruction process configuration
 * All fields are optional for partial updates
 */
export class UpdateDestructionProcessConfigRequestDto extends ConditionalPartial(
    CreateDestructionProcessConfigRequestDto,
) {}
